<template>
  <div
    class="dui-label-group"
    :class="{ 'empty': isEmpty }"
  >
    <span
      v-for="(label, index) in labels"
      :key="index"
      class="label-item"
      :class="getLabelClasses(label)"
    >
      <span class="text">{{ label.text }}</span>
      <a
        v-if="allowRemoval"
        class="button-icon button-close"
        :class="getButtonClasses(label)"
        @click="removeLabel(label)"
      />
    </span>
  </div>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';
import storeKey from '@dui/mixins/store-key';

export default {
  mixins: [
    coloredComponent,
    storeKey,
  ],
  props: {
    allowRemoval: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
  },
  computed: {
    isEmpty() {
      return !this.labels || !this.labels.length;
    },
    labels() {
      return this.loadFromStore();
    },
  },
  methods: {
    getButtonClasses(label) {
      const colorClass = this.getButtonColorClass(label);
      const sizeClass = this.getButtonSizeClass(label);

      return sizeClass ? `${ colorClass } ${ sizeClass }` : colorClass;
    },
    getButtonColorClass(label) {
      if (label.color) {
        return `button-${ label.color }`;
      }
      if (this.color) {
        return `button-${ this.color }`;
      }

      return 'button';
    },
    getButtonSizeClass(label) {
      if (label.size) {
        return `button-${ label.size }`;
      }
      if (this.size) {
        return `button-${ this.size }`;
      }

      return null;
    },
    getLabelClasses(label) {
      const colorClass = this.getLabelColorClass(label);
      const sizeClass = this.getLabelSizeClass(label);

      return sizeClass ? `${ colorClass } ${ sizeClass }` : colorClass;
    },
    getLabelColorClass(label) {
      if (label.color) {
        return `label-${ label.color }`;
      }
      if (this.color) {
        return `label-${ this.color }`;
      }

      return 'label';
    },
    getLabelSizeClass(label) {
      if (label.size) {
        return `label-${ label.size }`;
      }
      if (this.size) {
        return `label-${ this.size }`;
      }

      return null;
    },
    removeLabel(label) {
      if (!this.allowRemoval || !this.storeUpdateKey) {
        return;
      }

      this.$store.dispatch(this.storeUpdateKey, label);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-label-group {
  margin: 0 (-$_1em);

  &[disabled] {
    pointer-events: none;
  }

  &.empty {
    margin: 0;
  }

  > .label-item {
    margin: $_1em;

    .button-icon,
    .text {
      display: inline-block;
      vertical-align: middle;
    }

    .button-icon {
      margin: 0 0 0 $_0-5em;

      &:not(.button-sm) {
        height: $_4em;
        margin-right: (-$_1em);
        width: $_4em;

        &:before {
          height: $_1-5em;
          width: $_1-5em;
        }
      }
    }
  }
}
</style>
